(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_timezone"] && !Shopify.designMode) return;
  try {
    class TimezoneDisplay extends HTMLElement {
    constructor() {
      super();
      this.timezone = this.dataset.timezone;
      this.timezoneAbbr = this.dataset.timezoneAbbr;
      this.timeValue = this.querySelector('.timezone__time-value');
      this.timeZone = this.querySelector('.timezone__time-zone');
    }

    connectedCallback() {
      this.updateTime();
      this.interval = setInterval(() => this.updateTime(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    updateTime() {
      try {
        const now = new Date();

        // Format time (HH:MM)
        const timeFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone: this.timezone,
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });

        this.timeValue.textContent = timeFormatter.format(now);
        this.timeZone.textContent = this.timezoneAbbr || '---';
      } catch (err) {
        console.error('Failed to update timezone:', err);
        this.timeValue.textContent = '--:--';
        this.timeZone.textContent = '---';
      }
    }
  }

  if (!customElements.get('timezone-display')) {
    customElements.define('timezone-display', TimezoneDisplay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-banner"] && !Shopify.designMode) return;
  try {
    // Email copy-to-clipboard feedback
  (function () {
    function fallbackCopy(value) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      var succeeded = false;
      try {
        succeeded = document.execCommand('copy');
      } catch (err) {
        succeeded = false;
      }

      document.body.removeChild(textarea);
      return succeeded;
    }

    var COPIED_MS = 3000;
    var toast = null;
    var toastTimeout = null;

    function getToast() {
      if (toast) return toast;
      toast = document.createElement('div');
      toast.className = 'footer-banner__toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<span class="footer-banner__toast-text"></span>';
      document.body.appendChild(toast);
      return toast;
    }

    function showCopied(wrapper) {
      if (wrapper.copiedTimeout) clearTimeout(wrapper.copiedTimeout);
      if (toastTimeout) clearTimeout(toastTimeout);

      // Copied state on the icon plus a toast at the bottom of the viewport.
      wrapper.classList.add('footer-banner__email-display--copied');
      var el = getToast();
      el.querySelector('.footer-banner__toast-text').textContent = 'Email copied';
      el.classList.remove('footer-banner__toast--visible');
      requestAnimationFrame(function () {
        el.classList.add('footer-banner__toast--visible');
      });

      toastTimeout = setTimeout(function () {
        el.classList.remove('footer-banner__toast--visible');
        toastTimeout = null;
      }, COPIED_MS);
      wrapper.copiedTimeout = setTimeout(function () {
        wrapper.classList.remove('footer-banner__email-display--copied');
        wrapper.copiedTimeout = null;
      }, COPIED_MS);
    }

    document.addEventListener('DOMContentLoaded', function () {
      var wrappers = document.querySelectorAll('[data-copy-email]');

      wrappers.forEach(function (wrapper) {
        var button = wrapper.querySelector('.footer-banner__email-button');
        var value = wrapper.dataset.copyEmail;

        if (!button || !value) return;

        button.addEventListener('click', function () {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value).then(
              function () {
                showCopied(wrapper);
              },
              function () {
                if (fallbackCopy(value)) {
                  showCopied(wrapper);
                }
              }
            );
          } else if (fallbackCopy(value)) {
            showCopied(wrapper);
          }
        });
      });
    });
  })();

  // Video hover functionality (desktop only)
  document.addEventListener('DOMContentLoaded', () => {
    const footerBanners = document.querySelectorAll('.footer-banner');

    footerBanners.forEach(banner => {
      const content = banner.querySelector('.footer-banner__content');
      const video = banner.querySelector('.footer-banner__video-background video');

      if (video && content && window.matchMedia('(min-width: 1025px)').matches) {
        let isPlaying = false;
        let isTransitioning = false;
        let isVideoReady = false;

        // Ensure video is loaded
        const ensureVideoReady = () => {
          return new Promise((resolve) => {
            if (video.readyState >= 3) {
              // HAVE_FUTURE_DATA or greater
              resolve();
            } else {
              video.addEventListener('canplay', () => resolve(), { once: true });
              video.load();
            }
          });
        };

        const checkAndPlay = async () => {
          if (isPlaying || isTransitioning) return;

          isTransitioning = true;

          if (!isVideoReady) {
            await ensureVideoReady();
            isVideoReady = true;
          }

          // Check if still hovering after async wait
          if (!content.matches(':hover')) {
            isTransitioning = false;
            return;
          }

          video.currentTime = 0;

          try {
            await video.play();
            isPlaying = true;
          } catch (err) {
            console.error('Video play failed:', err);
          } finally {
            isTransitioning = false;
          }
        };

        const checkAndPause = () => {
          if (isTransitioning) return;

          // Use requestAnimationFrame to ensure we check after event propagation
          requestAnimationFrame(() => {
            const isHovering = content.matches(':hover');

            if (!isHovering && isPlaying && !isTransitioning) {
              isPlaying = false;
              video.pause();
            }
          });
        };

        content.addEventListener('mouseenter', checkAndPlay);
        content.addEventListener('mouseleave', checkAndPause);

        // Extra safety: pause on any mouse movement outside the content box
        document.addEventListener('mousemove', (e) => {
          if (isPlaying && !isTransitioning) {
            const rect = content.getBoundingClientRect();
            const isInsideContent = (
              e.clientX >= rect.left &&
              e.clientX <= rect.right &&
              e.clientY >= rect.top &&
              e.clientY <= rect.bottom
            );

            if (!isInsideContent) {
              isPlaying = false;
              video.pause();
            }
          }
        });

        // Preload video on page load
        ensureVideoReady().then(() => {
          isVideoReady = true;
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p3-carousel"] && !Shopify.designMode) return;
  try {
    class P3CarouselElement extends HTMLElement {
    constructor() {
      super();
      this.splideInstance = null;
      this.splideLoaded = false;
      this._progressResizeHandler = null;
      this._hoverScrollLastTime = 0;
      this._hoverScrollThrottle = 800;
    }

    connectedCallback() {
      // Scope the nested-subgrid workaround to Safari; Chromium keeps its
      // existing layout. iOS browsers with their own branding are excluded.
      const isSafari = navigator.vendor === 'Apple Computer, Inc.' &&
        /Safari\//.test(navigator.userAgent) &&
        !/Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android/.test(navigator.userAgent);
      this.classList.toggle('p3-carousel--safari', isSafari);
      this.loadSplide()
        .then(() => this.initCarousel())
        .catch(() => {
          this.classList.add('p3-carousel--load-error');
        });
    }

    loadSplide() {
      return new Promise((resolve, reject) => {
        // Check if Splide is already loaded
        if (typeof Splide !== 'undefined') {
          this.splideLoaded = true;
          resolve();
          return;
        }

        // Check if script is already being loaded
        const existingScript = document.querySelector('script[src*="splide"]');
        if (existingScript) {
          existingScript.addEventListener('load', () => {
            this.splideLoaded = true;
            resolve();
          });
          existingScript.addEventListener('error', () => reject(new Error('Splide script failed to load')));
          return;
        }

        // Load CSS
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
        link.onerror = () => reject(new Error('Splide CSS failed to load'));
        document.head.appendChild(link);

        // Load JS
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
        script.onload = () => {
          this.splideLoaded = true;
          resolve();
        };
        script.onerror = () => reject(new Error('Splide script failed to load'));
        document.head.appendChild(script);
      });
    }

    initCarousel() {
      if (!this.splideLoaded || typeof Splide === 'undefined') {
        console.error('P3 Carousel: Splide not loaded');
        return;
      }

      const splideElement = this.querySelector('.splide');
      if (!splideElement) {
        console.error('P3 Carousel: .splide element not found');
        return;
      }

      const splideList = splideElement.querySelector('.splide__list');
      if (!splideList) {
        console.error('P3 Carousel: .splide__list not found');
        return;
      }

      // Wrap each child element in a splide__slide li (filter out text nodes, comments, and video overlays)
      const children = Array.from(splideList.children).filter(child =>
        child.nodeType === 1 &&
        !child.classList.contains('splide__slide') &&
        !child.classList.contains('p3-video-overlay') &&
        child.tagName !== 'SCRIPT' &&
        child.tagName !== 'STYLE'
      );
      children.forEach(child => {
        const slide = document.createElement('li');
        slide.className = 'splide__slide';
        child.parentNode.insertBefore(slide, child);
        slide.appendChild(child);
      });

      const slides = splideElement.querySelectorAll('.splide__slide');
      const desktopSlides = parseInt(this.dataset.desktopSlides) || 3;
      const mobileSlides = parseInt(this.dataset.mobileSlides) || 1;
      const desktopPeek = parseInt(this.dataset.desktopPeek) || 0;
      const mobilePeek = parseInt(this.dataset.mobilePeek) || 0;
      const showPagination = this.dataset.showPagination === 'true';

      const isDesktop = window.innerWidth >= 750;

      const config = {
        type: 'loop',
        perMove: 1,
        gap: '20px',
        speed: 450,
        pagination: showPagination,
        arrows: false,
        fixedWidth: isDesktop ? '420px' : '250px',
        fixedHeight: isDesktop ? '635px' : '454.48px',
        perPage: isDesktop ? desktopSlides : mobileSlides,
        breakpoints: {
          // Mobile uses the native scroll-snap row (same pattern as the media
          // grid); Splide only drives the desktop carousel.
          749: {
            destroy: true,
          }
        }
      };

      if (desktopPeek > 0) {
        config.padding = { right: `${desktopPeek}%` };
      }
      // mobilePeek is a legacy setting: on mobile the next card peeks naturally
      // because the row scrolls.
      void mobilePeek;

      try {
        this.splideInstance = new Splide(splideElement, config);
        this.splideInstance.mount();

        if (showPagination) {
          this.setupMobileProgress();
        }

        this.setupHoverScroll();

      } catch (error) {
        console.error('P3 Carousel: Error mounting', error);
      }
    }

    setupHoverScroll() {
      const leftZone = this.querySelector('[data-carousel-hover="left"]');
      const rightZone = this.querySelector('[data-carousel-hover="right"]');
      if (!leftZone || !rightZone || !this.splideInstance) return;

      const onMove = (direction) => {
        const now = Date.now();
        if (now - this._hoverScrollLastTime < this._hoverScrollThrottle) return;
        this._hoverScrollLastTime = now;
        requestAnimationFrame(() => {
          if (!this.splideInstance) return;
          if (direction === 'left') this.splideInstance.go('<');
          else this.splideInstance.go('>');
        });
      };

      leftZone.addEventListener('mousemove', () => onMove('left'), { passive: true });
      rightZone.addEventListener('mousemove', () => onMove('right'), { passive: true });
    }

    setupMobileProgress() {
      const progress = this.querySelector('[data-carousel-progress]');
      const thumb = this.querySelector('[data-carousel-progress-thumb]');
      const track = this.querySelector('.splide__track');
      if (!progress || !thumb || !track) return;
      // Fills from the left as the row scrolls, like the media grid scroll bar.
      const MIN_PERCENT = 10;
      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) {
          thumb.style.width = '100%';
          return;
        }
        // The last card snaps by its end (see the stylesheet), so the row
        // reaches maxScroll and the bar fills completely; the 4px tolerance
        // covers fractional scroll positions (PMNS-106).
        const atEnd = maxScroll - track.scrollLeft <= 4;
        const ratio = atEnd ? 1 : Math.min(1, Math.max(0, track.scrollLeft / maxScroll));
        thumb.style.width = `${Math.max(MIN_PERCENT, ratio * 100)}%`;
      };
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          update();
        });
      }, { passive: true });
      // iOS does not fire scroll events reliably through the momentum and the
      // snap settle, so the bar kept the last value it saw and stopped short of
      // the end. Re-read the position once the gesture is over (PMNS-106).
      const settle = () => [0, 80, 200, 400, 700].forEach((ms) => window.setTimeout(update, ms));
      ['touchend', 'touchcancel', 'scrollend'].forEach((name) => {
        track.addEventListener(name, settle, { passive: true });
      });
      requestAnimationFrame(update);
      this._progressResizeHandler = update;
      window.addEventListener('resize', this._progressResizeHandler, { passive: true });
    }
    disconnectedCallback() {
      if (this.splideInstance) {
        this.splideInstance.destroy();
      }
      if (this._progressResizeHandler) {
        window.removeEventListener('resize', this._progressResizeHandler);
        this._progressResizeHandler = null;
      }
    }
  }

  if (!customElements.get('p3-carousel-element')) {
    customElements.define('p3-carousel-element', P3CarouselElement);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p3-curved-media-slider"] && !Shopify.designMode) return;
  try {
    function initP3CurvedMediaSliders() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.p3-curved-media-slider').forEach((slider) => {
      if (slider.dataset.swiperInitialized === 'true') return;

      slider.dataset.swiperInitialized = 'true';

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        speed: 600,
        navigation: {
          nextEl: slider.querySelector('.p3-curved-media-slider__arrow--next'),
          prevEl: slider.querySelector('.p3-curved-media-slider__arrow--prev'),
        },
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initP3CurvedMediaSliders);
  document.addEventListener('shopify:section:load', initP3CurvedMediaSliders);
  document.addEventListener('shopify:block:select', initP3CurvedMediaSliders);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p3-feature-video-preview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('video[data-p3-lazy-video]');
    if (!videos.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const activate = (video) => {
      if (video.dataset.p3Loaded) return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      video.dataset.p3Loaded = '1';
      video.load();
      if (!prefersReducedMotion) {
        video.play().catch(() => {});
      }
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (!video.dataset.p3Loaded) {
            activate(video);
          } else if (!prefersReducedMotion) {
            video.play().catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach((video) => observer.observe(video));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p3-form"] && !Shopify.designMode) return;
  try {
    (function() {
    var CC_MAP = {
      '1':'US/Canada','7':'Russia','20':'Egypt','27':'South Africa',
      '30':'Greece','31':'Netherlands','32':'Belgium','33':'France',
      '34':'Spain','36':'Hungary','39':'Italy','40':'Romania',
      '41':'Switzerland','43':'Austria','44':'UK','45':'Denmark',
      '46':'Sweden','47':'Norway','48':'Poland','49':'Germany',
      '51':'Peru','52':'Mexico','54':'Argentina','55':'Brazil',
      '56':'Chile','57':'Colombia','60':'Malaysia','61':'Australia',
      '62':'Indonesia','63':'Philippines','64':'New Zealand',
      '65':'Singapore','66':'Thailand','81':'Japan','82':'South Korea',
      '84':'Vietnam','86':'China','90':'Turkey','91':'India',
      '92':'Pakistan','98':'Iran','212':'Morocco','213':'Algeria',
      '216':'Tunisia','234':'Nigeria','254':'Kenya','255':'Tanzania',
      '256':'Uganda','351':'Portugal','353':'Ireland','358':'Finland',
      '380':'Ukraine','385':'Croatia','386':'Slovenia','420':'Czech Republic',
      '421':'Slovakia','506':'Costa Rica','507':'Panama','591':'Bolivia',
      '593':'Ecuador','595':'Paraguay','598':'Uruguay','852':'Hong Kong',
      '886':'Taiwan','960':'Maldives','961':'Lebanon','962':'Jordan',
      '963':'Syria','964':'Iraq','965':'Kuwait','966':'Saudi Arabia',
      '971':'UAE','972':'Israel','973':'Bahrain','974':'Qatar','977':'Nepal'
    };

    function detectCountry(digitsStr) {
      for (var len = 3; len >= 1; len--) {
        var code = digitsStr.slice(0, len);
        if (CC_MAP[code]) return { code: '+' + code, country: CC_MAP[code] };
      }
      return null;
    }

    function validatePhone(input, errorEl, hintEl) {
      var val = input.value.trim();
      if (!val) {
        errorEl.textContent = '';
        hintEl.textContent  = '';
        input.classList.remove('p3-form__input--error');
        return true;
      }
      if (/[^\d\s+\-()·.]/.test(val)) {
        errorEl.textContent = 'Phone number contains invalid characters. Use only digits, +, -, spaces, or parentheses.';
        hintEl.textContent  = '';
        input.classList.add('p3-form__input--error');
        return false;
      }
      var digits = val.replace(/\D/g, '');
      if (val.charAt(0) === '+' && digits.length > 0) {
        var detected = detectCountry(digits);
        hintEl.textContent = detected
          ? 'Detected: ' + detected.country + ' (' + detected.code + ')'
          : 'International format detected';
      } else {
        hintEl.textContent = '';
      }
      if (digits.length < 7) {
        errorEl.textContent = 'Phone number is too short (minimum 7 digits).';
        input.classList.add('p3-form__input--error');
        return false;
      }
      if (digits.length > 15) {
        errorEl.textContent = 'Phone number is too long (maximum 15 digits).';
        input.classList.add('p3-form__input--error');
        return false;
      }
      errorEl.textContent = '';
      input.classList.remove('p3-form__input--error');
      return true;
    }

    function validateRequired(input, errorEl, minLength) {
      var val = input.value.trim();
      if (!val) {
        errorEl.textContent = 'This field is required.';
        input.classList.add('p3-form__input--error');
        return false;
      }
      if (minLength && val.length < minLength) {
        errorEl.textContent = 'Please provide at least ' + minLength + ' characters (currently ' + val.length + ').';
        input.classList.add('p3-form__input--error');
        return false;
      }
      errorEl.textContent = '';
      input.classList.remove('p3-form__input--error');
      return true;
    }

    function clearFieldError(input, errorEl) {
      input.classList.remove('p3-form__input--error');
      errorEl.textContent = '';
    }

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function validateEmail(input, errorEl) {
      var val = input.value.trim();
      if (!val) {
        errorEl.textContent = 'Business email is required.';
        input.classList.add('p3-form__input--error');
        input.setAttribute('aria-invalid', 'true');
        return false;
      }
      if (!EMAIL_RE.test(val)) {
        errorEl.textContent = 'Please enter a valid email address (e.g. name@company.com).';
        input.classList.add('p3-form__input--error');
        input.setAttribute('aria-invalid', 'true');
        return false;
      }
      errorEl.textContent = '';
      input.classList.remove('p3-form__input--error');
      input.setAttribute('aria-invalid', 'false');
      return true;
    }

    function validateConsent(input, errorEl) {
      if (!input.checked) {
        errorEl.textContent = 'Please accept the terms to continue.';
        input.setAttribute('aria-invalid', 'true');
        return false;
      }
      errorEl.textContent = '';
      input.setAttribute('aria-invalid', 'false');
      return true;
    }

    window.p3FormCloseDialog = function() {
      var dialog = document.getElementById('thankYouDialog');
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        if (dialog.open) dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    function p3FormShowThankYouDialog() {
      var dialog = document.getElementById('thankYouDialog');
      if (!dialog) return;

      if (!dialog.hasAttribute('data-backdrop-bound')) {
        dialog.setAttribute('data-backdrop-bound', '');
        // Clicks on the backdrop land on the dialog element itself, outside its box.
        dialog.addEventListener('click', function(event) {
          if (event.target !== dialog) return;
          var rect = dialog.getBoundingClientRect();
          var inside = event.clientX >= rect.left && event.clientX <= rect.right &&
            event.clientY >= rect.top && event.clientY <= rect.bottom;
          if (!inside) window.p3FormCloseDialog();
        });
      }

      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    // Draft persistence: the form posts natively (Shopify's captcha needs the
    // real round trip), so what the user typed is kept in sessionStorage and
    // put back after the reload when Shopify comes back with errors or after
    // the captcha challenge. Cleared on success. Consent is never restored:
    // it has to be ticked again on purpose.
    var DRAFT_KEY = 'p3-form-draft:' + window.location.pathname;
    var DRAFT_TTL_MS = 60 * 60 * 1000;

    function p3FormDraftFields(form) {
      return Array.prototype.filter.call(form.elements, function(el) {
        return el.name && el.name.indexOf('contact[') === 0 && el.type !== 'checkbox' && el.type !== 'hidden';
      });
    }

    function p3FormSaveDraft(form, submitted) {
      try {
        var values = {};
        p3FormDraftFields(form).forEach(function(el) { values[el.name] = el.value; });
        window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify({ savedAt: Date.now(), submitted: !!submitted, values: values }));
      } catch (err) { /* storage unavailable: nothing to restore later */ }
    }

    function p3FormClearDraft() {
      try { window.sessionStorage.removeItem(DRAFT_KEY); } catch (err) { /* ignore */ }
    }

    function p3FormStorageAvailable() {
      try { return !!window.sessionStorage; } catch (err) { return false; }
    }

    function p3FormReadDraft() {
      var raw = null;
      try { raw = window.sessionStorage.getItem(DRAFT_KEY); } catch (err) { return null; }
      if (!raw) return null;
      var draft;
      try { draft = JSON.parse(raw); } catch (err) { p3FormClearDraft(); return null; }
      if (!draft || !draft.values || Date.now() - (draft.savedAt || 0) > DRAFT_TTL_MS) { p3FormClearDraft(); return null; }
      return draft;
    }

    // The submitted flag only counts for two minutes: enough for the post, the
    // redirect and a captcha challenge, not for a later reload of the page.
    var SUBMIT_TTL_MS = 2 * 60 * 1000;

    function p3FormJustSubmitted(draft) {
      return !!draft && draft.submitted === true && Date.now() - (draft.savedAt || 0) <= SUBMIT_TTL_MS;
    }

    function p3FormRestoreDraft(form, draft) {
      p3FormDraftFields(form).forEach(function(el) {
        // Values Shopify re-rendered itself (e.g. the email on error) win.
        if (el.value === '' && typeof draft.values[el.name] === 'string') el.value = draft.values[el.name];
      });
    }

    document.addEventListener('DOMContentLoaded', function() {
      var draftForm = document.getElementById('P3ContactForm');
      var draft = p3FormReadDraft();
      var justSubmitted = p3FormJustSubmitted(draft);
      // The scroll position after the round trip is restored by p3-scroll-restore.js.
      if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
        window.history.replaceState({}, '', window.location.pathname);
        // Only a submission from the last two minutes gets the dialog, not a
        // reload or a shared link that still carries the parameter. Without
        // storage there is no way to tell, so the parameter alone decides.
        if (justSubmitted || !p3FormStorageAvailable()) p3FormShowThankYouDialog();
        p3FormClearDraft();
      } else if (draftForm && draft) {
        p3FormRestoreDraft(draftForm, draft);
        // Came back without success (Shopify's form.errors or the captcha
        // challenge): keep the values but drop the flag, so a later reload is
        // not taken for another round trip.
        if (justSubmitted) p3FormSaveDraft(draftForm, false);
      }
      if (draftForm) {
        var draftTimer = null;
        draftForm.addEventListener('input', function() {
          window.clearTimeout(draftTimer);
          draftTimer = window.setTimeout(function() { p3FormSaveDraft(draftForm); }, 300);
        });
      }

      var phoneInput = document.getElementById('P3ContactForm-phone');
      var phoneError = document.getElementById('P3ContactForm-phone-error');
      var phoneHint  = document.getElementById('P3ContactForm-phone-hint');
      if (phoneInput && phoneError && phoneHint) {
        phoneInput.addEventListener('input', function() {
          validatePhone(phoneInput, phoneError, phoneHint);
        });
        phoneInput.addEventListener('blur', function() {
          validatePhone(phoneInput, phoneError, phoneHint);
        });
      }

      var emailInput = document.getElementById('P3ContactForm-email');
      var emailError = document.getElementById('P3ContactForm-email-error');
      if (emailInput && emailError) {
        emailInput.addEventListener('input', function() {
          validateEmail(emailInput, emailError);
        });
        emailInput.addEventListener('blur', function() {
          validateEmail(emailInput, emailError);
        });
      }

      var consentInput = document.getElementById('P3ContactForm-consent');
      var consentError = document.getElementById('P3ContactForm-consent-error');
      if (consentInput && consentError) {
        consentInput.addEventListener('change', function() {
          validateConsent(consentInput, consentError);
        });
      }

      var companyInput = document.getElementById('P3ContactForm-company');
      var companyError = document.getElementById('P3ContactForm-company-error');
      if (companyInput && companyError) {
        companyInput.addEventListener('input', function() {
          if (companyInput.value.trim()) clearFieldError(companyInput, companyError);
        });
      }

      var projectInput = document.getElementById('P3ContactForm-project');
      var projectError = document.getElementById('P3ContactForm-project-error');
      if (projectInput && projectError) {
        projectInput.addEventListener('input', function() {
          var len = projectInput.value.trim().length;
          if (len === 0) {
            projectError.textContent = '';
            projectInput.classList.remove('p3-form__input--error');
          } else if (len < 20) {
            projectError.textContent = len + ' / 20 characters minimum.';
            projectInput.classList.add('p3-form__input--error');
          } else {
            clearFieldError(projectInput, projectError);
          }
        });
      }

      var form = document.getElementById('P3ContactForm');
      if (form) {
        // Set programmatically instead of in the markup: if this script fails to
        // load, native constraint validation still guards the required fields
        // (and the optional website URL field) instead of nothing at all.
        form.setAttribute('novalidate', 'novalidate');

        // Submit stays disabled until the required fields (business email,
        // company name, project description) are filled in and valid and the
        // consent box is ticked. The phone is still checked by the submit
        // handler below. Set here rather than in the markup, so the form can
        // still be sent if this script fails to load.
        var submitButton = form.querySelector('button[type="submit"]');
        var p3FormIsComplete = function() {
          if (!emailInput || !EMAIL_RE.test(emailInput.value.trim())) return false;
          if (companyInput && !companyInput.value.trim()) return false;
          if (projectInput && projectInput.value.trim().length < 20) return false;
          if (consentInput && !consentInput.checked) return false;
          return true;
        };
        var loading = false;
        var loadingTimer = null;

        var updateSubmitState = function() {
          if (submitButton) submitButton.disabled = loading || !p3FormIsComplete();
        };

        // Spinner while the captcha runs and the post goes out. The page
        // normally navigates away; if nothing is posted (captcha error), the
        // button comes back after a while instead of spinning forever.
        var setLoading = function(on) {
          loading = on;
          window.clearTimeout(loadingTimer);
          if (submitButton) {
            submitButton.classList.toggle('is-loading', on);
            submitButton.setAttribute('aria-busy', on ? 'true' : 'false');
          }
          if (on) loadingTimer = window.setTimeout(function() { setLoading(false); }, 20000);
          updateSubmitState();
        };

        form.addEventListener('input', updateSubmitState);
        // Autofill and the checkbox report through change, not always input.
        form.addEventListener('change', updateSubmitState);
        // Back/forward cache restores the page as it was left, spinner included,
        // and field values without firing either event.
        window.addEventListener('pageshow', function(event) {
          if (event.persisted) setLoading(false);
          else updateSubmitState();
        });
        updateSubmitState();

        // Capture phase on the document, not a listener on the form: Shopify's
        // captcha script binds its own submit listener to the form that ignores
        // preventDefault() and posts through HTMLFormElement.prototype.submit
        // once hCaptcha resolves, so invalid forms still went through. Stopping
        // the event here, before it reaches the form, keeps that listener out.
        document.addEventListener('submit', function(e) {
          if (e.target !== form) return;
          var isValid = true;

          if (phoneInput && phoneError && phoneHint) {
            if (!validatePhone(phoneInput, phoneError, phoneHint)) isValid = false;
          }
          if (emailInput && emailError) {
            if (!validateEmail(emailInput, emailError)) isValid = false;
          }
          if (companyInput && companyError) {
            if (!validateRequired(companyInput, companyError, 0)) isValid = false;
          }
          if (projectInput && projectError) {
            if (!validateRequired(projectInput, projectError, 20)) isValid = false;
          }
          if (consentInput && consentError) {
            if (!validateConsent(consentInput, consentError)) isValid = false;
          }

          if (!isValid) {
            e.preventDefault();
            e.stopPropagation();
            var firstErr = form.querySelector('.p3-form__input--error') ||
              (consentInput && !consentInput.checked ? consentInput : null);
            if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }

          // Validation passed: the form posts natively (Shopify's captcha needs
          // the real round trip) and return_to brings the user back here. Save
          // the draft with the submitted flag first so the next load knows it
          // is that round trip. Cancel the pending debounced save, or it would
          // overwrite this one and drop the flag.
          window.clearTimeout(draftTimer);
          p3FormSaveDraft(form, true);
          setLoading(true);
        }, true);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p3-testimonial"] && !Shopify.designMode) return;
  try {
    const CONTROLS_HIDE_DELAY_MS = 2000;

  // --- Body scroll lock ---------------------------------------------------
  // iOS Safari ignores overflow: hidden for touch scrolling, so the body is
  // pinned with position: fixed at the current offset and restored on close
  // with an instant scroll (the html element uses scroll-behavior: smooth).
  let lockedScrollY = null;

  function lockBodyScroll() {
    if (lockedScrollY !== null) return;
    lockedScrollY = window.scrollY;
    const { style } = document.body;
    style.position = 'fixed';
    style.top = `-${lockedScrollY}px`;
    style.left = '0';
    style.right = '0';
    style.width = '100%';
    style.overflow = 'hidden';
    document.documentElement.setAttribute('scroll-lock', '');
  }

  function unlockBodyScroll() {
    if (lockedScrollY === null) return;
    const scrollY = lockedScrollY;
    lockedScrollY = null;
    const { style } = document.body;
    style.position = '';
    style.top = '';
    style.left = '';
    style.right = '';
    style.width = '';
    style.overflow = '';
    document.documentElement.removeAttribute('scroll-lock');
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  }

  // --- Background videos ---------------------------------------------------
  // Only one dialog can be open at a time, so the state is shared.
  let pausedBackgroundVideos = [];

  function pauseBackgroundVideos(exceptVideo) {
    pausedBackgroundVideos = [];
    document.querySelectorAll('video').forEach((v) => {
      if (v !== exceptVideo && !v.paused) {
        v.pause();
        pausedBackgroundVideos.push(v);
      }
    });
  }

  function resumeBackgroundVideos() {
    pausedBackgroundVideos.forEach((v) => {
      const playPromise = v.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
    pausedBackgroundVideos = [];
  }

  // --- Video dialog ---------------------------------------------------------
  const STOP_AT_DIALOG_EVENTS = [
    'pointerdown',
    'pointermove',
    'pointerup',
    'touchstart',
    'touchmove',
    'touchend',
    'mousedown',
    'mousemove',
    'mouseup',
  ];

  class TestimonialVideoDialog {
    constructor(dialog) {
      this.dialog = dialog;
      this.video = dialog.querySelector('video');
      this.wrapper = dialog.querySelector('[data-video-wrapper]');
      this.button = dialog.querySelector('[data-dialog-video-control]');
      this.playIcon = dialog.querySelector('.p3-video-dialog__play-icon');
      this.pauseIcon = dialog.querySelector('.p3-video-dialog__pause-icon');
      this.hideControlsTimeout = null;

      if (this.video && this.wrapper && this.button && this.playIcon && this.pauseIcon) {
        this.bind();
      }
    }

    bind() {
      this.video.pause();
      this.updateButtonState();

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      });

      // Clicking or tapping the picture itself toggles playback too.
      this.video.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      });

      this.wrapper.addEventListener('mousemove', () => {
        if (!this.video.paused) this.showControls();
      });

      this.video.addEventListener('play', () => {
        this.updateButtonState();
        this.hideControls();
      });
      ['pause', 'ended'].forEach((type) => {
        this.video.addEventListener(type, () => {
          this.updateButtonState();
          this.showControls(true);
        });
      });

      // The dialog sits in the top layer but the events still bubble through
      // the DOM; keep them away from the carousel drag handlers underneath.
      STOP_AT_DIALOG_EVENTS.forEach((type) => {
        this.dialog.addEventListener(type, (event) => event.stopPropagation());
      });

      // Backdrop click: anything that is not the video wrapper.
      this.dialog.addEventListener('click', (event) => {
        if (this.wrapper.contains(event.target)) return;
        this.close();
      });

      this.dialog.addEventListener('close', () => this.onClose());
    }

    open() {
      if (this.dialog.open) return;
      preservePreviewLayouts();
      pauseBackgroundVideos(this.video);
      lockBodyScroll();
      this.dialog.showModal();
      // Do not seek here: setting currentTime makes the browser paint the
      // real first frame over the poster (black on fade-in videos).
      this.video.pause();
      this.showControls(true);
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    onClose() {
      this.video.pause();
      // load() resets playback to the start and brings the poster back for
      // the next open; a plain currentTime = 0 would leave frame 0 on screen.
      this.video.load();
      this.showControls(true);
      unlockBodyScroll();
      resumeBackgroundVideos();
    }

    isPlaying() {
      return !this.video.paused && !this.video.ended;
    }

    updateButtonState() {
      const playing = this.isPlaying();
      this.playIcon.style.display = playing ? 'none' : 'block';
      this.pauseIcon.style.display = playing ? 'block' : 'none';
    }

    showControls(persist = false) {
      window.clearTimeout(this.hideControlsTimeout);
      this.wrapper.classList.add('show-controls');
      if (persist || !this.isPlaying()) return;
      this.hideControlsTimeout = window.setTimeout(() => this.hideControls(), CONTROLS_HIDE_DELAY_MS);
    }

    hideControls() {
      window.clearTimeout(this.hideControlsTimeout);
      this.wrapper.classList.remove('show-controls');
    }

    toggle() {
      if (this.isPlaying()) {
        this.video.pause();
        return;
      }
      this.video.muted = false;
      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }
  }

  const dialogControllers = new Map();

  function initVideoDialogs() {
    document.querySelectorAll('[data-video-dialog]').forEach((dialog) => {
      const id = dialog.dataset.videoDialog;
      const existing = dialogControllers.get(id);

      if (existing && existing.dialog === dialog) return;
      if (existing && existing.dialog.parentNode === document.body && dialog.parentNode !== document.body) {
        // A re-render (theme editor) produced a fresh copy: replace the old one.
        existing.close();
        existing.dialog.remove();
      } else if (existing) {
        // Duplicate (carousel clone): keep the one already wired up.
        dialog.remove();
        return;
      }

      // Move the dialog out of the carousel so it is never cloned and its
      // events never reach the slide drag handlers.
      document.body.appendChild(dialog);
      dialogControllers.set(id, new TestimonialVideoDialog(dialog));
    });
  }

  // --- Read more -------------------------------------------------------------
  function isTruncated(element) {
    return element.scrollHeight > element.clientHeight + 1;
  }

  function refreshReadMoreButtons() {
    document.querySelectorAll('.p3-testimonial').forEach((card) => {
      const button = card.querySelector('[data-read-more]');
      if (!button) return;
      if (card.classList.contains('p3-testimonial--expanded')) return;
      const paragraphs = card.querySelectorAll('.p3-testimonial__text p');
      const truncated = Array.prototype.some.call(paragraphs, isTruncated);
      button.hidden = !truncated;
    });
  }

  let readMoreRefreshRaf = null;
  function scheduleReadMoreRefresh() {
    document.querySelectorAll('.p3-testimonial[data-p3-preview-layout]').forEach((card) => {
      if (Number(card.dataset.p3PreviewLayout) === window.innerWidth) return;
      delete card.dataset.p3PreviewLayout;
      card.style.removeProperty('--p3-preview-content-height');
    });
    if (readMoreRefreshRaf !== null) return;
    readMoreRefreshRaf = window.requestAnimationFrame(() => {
      readMoreRefreshRaf = null;
      refreshReadMoreButtons();
    });
  }

  function preservePreviewLayouts(scope = document) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const layouts = Array.from(scope.querySelectorAll('.p3-carousel--safari .p3-testimonial:not([data-p3-preview-layout])'))
      .map((card) => ({ card, height: card.querySelector('.p3-testimonial__content-wrapper').getBoundingClientRect().height }));
    layouts.forEach(({ card, height }) => {
      card.style.setProperty('--p3-preview-content-height', `${height}px`);
      card.dataset.p3PreviewLayout = String(window.innerWidth);
    });
  }

  function toggleReadMore(button) {
    const card = button.closest('.p3-testimonial');
    if (!card) return;
    const expanded = card.classList.toggle('p3-testimonial--expanded');
    const content = card.querySelector('.p3-testimonial__content-wrapper');
    if (!content) return;
    const originalButton = content.querySelector('[data-read-more]');
    const video = card.querySelector('.p3-testimonial__video-wrapper');
    originalButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (expanded) {
      preservePreviewLayouts(card.closest('p3-carousel-element') || document);
      // Clone only copy and controls, never media. Leaving the original text
      // in its subgrid preserves every shared row's contribution and height.
      const overlay = content.cloneNode(true);
      overlay.classList.replace('p3-testimonial__content-wrapper', 'p3-testimonial__expanded-content');
      const closeButton = overlay.querySelector('[data-read-more]');
      closeButton.textContent = 'Read less';
      const layer = document.createElement('div');
      layer.className = 'p3-testimonial__reading-layer';
      layer.appendChild(overlay);
      card.appendChild(layer);
      content.inert = true;
      if (video) video.inert = true;
      closeButton.focus({ preventScroll: true });
    } else {
      preservePreviewLayouts(card.closest('p3-carousel-element') || document);
      card.querySelector('.p3-testimonial__reading-layer')?.remove();
      content.inert = false;
      if (video) video.inert = false;
      originalButton.focus({ preventScroll: true });
    }
  }

  // --- Wiring ----------------------------------------------------------------
  // Clicks are delegated so carousel clones (created after this runs) work too.
  document.addEventListener('click', (event) => {
    const readMore = event.target.closest('[data-read-more]');
    if (readMore) {
      event.preventDefault();
      toggleReadMore(readMore);
      return;
    }

    const trigger =
      event.target.closest('[data-video-trigger]') ||
      (event.target.closest('.p3-testimonial__video-wrapper') || document.createElement('div')).querySelector('[data-video-trigger]');
    if (!trigger) return;

    const controller = dialogControllers.get(trigger.dataset.videoId);
    if (!controller) return;
    event.preventDefault();
    controller.open();
  });

  function init() {
    initVideoDialogs();
    scheduleReadMoreRefresh();
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();

    window.addEventListener('load', scheduleReadMoreRefresh);
    window.addEventListener('resize', scheduleReadMoreRefresh);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleReadMoreRefresh);
    }

    // Carousel clones and theme-editor re-renders add cards later.
    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) =>
        Array.prototype.some.call(mutation.addedNodes, (node) =>
          node.nodeType === 1 && (node.matches('.p3-testimonial, .p3-testimonial-wrapper') || node.querySelector('.p3-testimonial'))
        )
      );
      if (relevant) scheduleReadMoreRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', init);
  } catch(e) { console.error(e); }
})();

})();
